import { render } from "./StatusHeader.vue?vue&type=template&id=2fdcc790&scoped=true"
import script from "./StatusHeader.vue?vue&type=script&lang=js"
export * from "./StatusHeader.vue?vue&type=script&lang=js"

import "./StatusHeader.vue?vue&type=style&index=0&id=2fdcc790&scoped=true&lang=css"

import exportComponent from "/Users/bruno/Documents/Codex/bam4-share-link-work/bam4-master/client/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.69.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fdcc790"]])

export default __exports__